import React from "react";
import _ from "lodash";

import "@ant-design/compatible/assets/index.css";
import {
  Button,
  Select,
  Radio,
  Table,
  Form,
  Row,
  Col,
  message,
  Tag,
} from "antd";
import {
  ASNEEDED,
  BIANNUALLY,
  DAILY,
  MONTHLY,
  QUARTERLY,
  WEEKLY,
  YEARLY,
} from "../../utils/report";

const { Option, OptGroup } = Select;

class FormFour extends React.Component {
  state = {
    signature_steps: "0",
    change: null,
  };

  formFourFormRef = React.createRef();

  async componentDidMount() {
    if (
      this.props.signersGroupsGetData &&
      this.props.signersGroupsGetData.signers_groups_option &&
      this.props.signersGroupsGetData.signers_groups_option.signature_steps
    ) {
      this.setState({ signature_steps: "1" });
    } else {
      this.setState({ signature_steps: "0" });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.signersGroupsGetData !== this.props.signersGroupsGetData) {
      this.formFourFormRef.current.resetFields();
      if (
        this.props.signersGroupsGetData &&
        this.props.signersGroupsGetData.signers_groups_option &&
        this.props.signersGroupsGetData.signers_groups_option.signature_steps
      ) {
        this.setState({ signature_steps: "1" });
      } else {
        this.setState({ signature_steps: "0" });
      }
    }
  }

  signatureStepsOnChange = (e) => {
    this.setState({ signature_steps: e.target.value });
  };

  usersAndGroupsOnChange = (value) => {
    console.log(value);
    this.setState({ change: value });
  };

  usersAndGroupsOnChangeNew = async (value, id, name) => {
    if (value) {
      for (const e of value) {
        if (e === "no_email") {
          message.error("Selected user doesn't have email.");
          const filterVal = value.filter((key) => key !== e.toString());
          this.formFourFormRef.current.setFieldsValue({
            [name]: { [id]: filterVal },
          });
        }

        if (e.substring(0, 2) === "g_") {
          if (
            this.props.signersGroupsGetData &&
            this.props.signersGroupsGetData.signers_groups
          ) {
            const result = this.props.signersGroupsGetData.signers_groups.find(
              (aa) => aa._id === e.replace("g_", "")
            );
            if (result && result.signers_group_users) {
              if (
                this.props.signersGroupsGetData &&
                this.props.signersGroupsGetData.out_of_office_all_assignees
              ) {
                const foundA0 = _.intersection(
                  this.props.signersGroupsGetData.out_of_office_all_assignees,
                  result.signers_group_users
                );
                if (foundA0.length > 0) {
                  message.error(
                    "This group has been assigned as an alternate signer view by out of the office."
                  );
                  const filterVal = value.filter((key) => key !== e.toString());
                  await this.formFourFormRef.current.setFieldsValue({
                    [name]: { [id]: filterVal },
                  });
                }
              }
            }
          }
        }
        if (e.substring(0, 2) === "u_") {
          if (
            this.props.signersGroupsGetData &&
            this.props.signersGroupsGetData.out_of_office_all_assignees
          ) {
            if (
              this.props.signersGroupsGetData.out_of_office_all_assignees.includes(
                e.replace("u_", "")
              )
            ) {
              message.error(
                "This user has been assigned as an alternate signer view by out of the office."
              );
              const filterVal = value.filter((key) => key !== e.toString());
              await this.formFourFormRef.current.setFieldsValue({
                [name]: { [id]: filterVal },
              });
            }
          }
        }
        // if(name != "users_and_groups"){
        //   if(e.substring(0, 2) === "g_"){
        //     message.error(
        //       "Group signers are not accepted"
        //     );
        //     const filterVal = value.filter((key) => key !== e.toString());
        //     await this.formFourFormRef.current.setFieldsValue({
        //       [name]: { [id]: filterVal },
        //     });
        //   }
        // }
      }
    }
    await this.setState({ change: value });
    this.formFourFormRef.current.validateFields();
  };

  render() {
    const { onFinish, onFinishFailed, signersGroupsGetData } = this.props;
    // const { getFieldValue, setFieldsValue } = form;

    let formValueNew = null;
    if (this.formFourFormRef && this.formFourFormRef.current) {
      formValueNew = this.formFourFormRef.current.getFieldValue();
    }

    const formFourInitialValues = {};
    const dailyReports = [];
    const weeklyReports = [];
    const monthlyReports = [];
    const yearlyReports = [];
    const quarterlyReports = [];
    const asNeededReports = [];
    const biAnnualReports = [];
    const formFourClerValues = {};
    const formFourClerValuesStep = {};
    let selectListUsers = [];
    let selectListGroups = [];
    const usersOptionsNew = {};
    const groupsOptionsNew = {};
    const stepOneUsersOptionsNew = {};
    const stepOneGroupsOptionsNew = {};
    const stepTwoUsersOptionsNew = {};
    const stepTwoGroupsOptionsNew = {};
    const validate = {};
    validate.users_and_groups = {};
    validate.users_and_groups_step_1 = {};
    validate.users_and_groups_step_2 = {};

    formFourInitialValues.signature_steps = "0";
    formFourInitialValues.signature_sheet_required_type = "3";
    formFourInitialValues.check_list = "0";
    formFourInitialValues.check_list_type = "Individual";
    formFourInitialValues.check_list_position = "Bottom";

    if (signersGroupsGetData && signersGroupsGetData.reports) {
      formFourInitialValues.users_and_groups = {};
      formFourInitialValues.users_and_groups_step_1 = {};
      formFourInitialValues.users_and_groups_step_2 = {};
      formFourClerValues.users_and_groups = {};
      formFourClerValuesStep.users_and_groups_step_1 = {};
      formFourClerValuesStep.users_and_groups_step_2 = {};
      signersGroupsGetData.reports.forEach((d) => {
        if (d.report_id) {
          const reportData = d.report_id;
          reportData.users_and_groups = [];
          formFourClerValues.users_and_groups[reportData._id] = [];
          formFourClerValuesStep.users_and_groups_step_1[reportData._id] = [];
          formFourClerValuesStep.users_and_groups_step_2[reportData._id] = [];

          formFourInitialValues.users_and_groups[reportData._id] = [];
          formFourInitialValues.users_and_groups_step_1[reportData._id] = [];
          formFourInitialValues.users_and_groups_step_2[reportData._id] = [];
          // console.log(d.report_id, "d.report_id");

          if (d.assigned_groups) {
            d.assigned_groups.forEach((g) => {
              // reportData.users_and_groups.push("g_" + g);
              formFourInitialValues.users_and_groups[reportData._id].push(
                "g_" + g
              );
            });
          }
          if (d.assigned_users) {
            d.assigned_users.forEach((u) => {
              // reportData.users_and_groups.push("u_" + u);
              formFourInitialValues.users_and_groups[reportData._id].push(
                "u_" + u
              );
            });
          }

          if (d.step_1 && d.step_1.assigned_groups) {
            d.step_1.assigned_groups.forEach((g) => {
              // reportData.users_and_groups.push("g_" + g);
              formFourInitialValues.users_and_groups_step_1[
                reportData._id
              ].push("g_" + g);
            });
          }
          if (d.step_1 && d.step_1.assigned_users) {
            d.step_1.assigned_users.forEach((u) => {
              // reportData.users_and_groups.push("u_" + u);
              formFourInitialValues.users_and_groups_step_1[
                reportData._id
              ].push("u_" + u);
            });
          }

          if (d.step_2 && d.step_2.assigned_groups) {
            d.step_2.assigned_groups.forEach((g) => {
              // reportData.users_and_groups.push("g_" + g);
              formFourInitialValues.users_and_groups_step_2[
                reportData._id
              ].push("g_" + g);
            });
          }
          if (d.step_2 && d.step_2.assigned_users) {
            d.step_2.assigned_users.forEach((u) => {
              // reportData.users_and_groups.push("u_" + u);
              formFourInitialValues.users_and_groups_step_2[
                reportData._id
              ].push("u_" + u);
            });
          }

          if (
            d.report_id &&
            d.report_id.shedule_type &&
            d.report_id.shedule_type === DAILY
          ) {
            dailyReports.push(d.report_id);
          }
          if (
            d.report_id &&
            d.report_id.shedule_type &&
            d.report_id.shedule_type === WEEKLY
          ) {
            weeklyReports.push(d.report_id);
          }
          if (
            d.report_id &&
            d.report_id.shedule_type &&
            d.report_id.shedule_type === MONTHLY
          ) {
            monthlyReports.push(d.report_id);
          }
          if (
            d.report_id &&
            d.report_id.shedule_type &&
            d.report_id.shedule_type === YEARLY
          ) {
            yearlyReports.push(d.report_id);
          }
          if (
            d.report_id &&
            d.report_id.shedule_type &&
            d.report_id.shedule_type === QUARTERLY
          ) {
            quarterlyReports.push(d.report_id);
          }
          if (
            d.report_id &&
            d.report_id.shedule_type &&
            d.report_id.shedule_type === ASNEEDED
          ) {
            asNeededReports.push(d.report_id);
          }
          if (
            d.report_id &&
            d.report_id.shedule_type &&
            d.report_id.shedule_type === BIANNUALLY
          ) {
            biAnnualReports.push(d.report_id);
          }

          usersOptionsNew[reportData._id] = [];
          groupsOptionsNew[reportData._id] = [];
          stepOneUsersOptionsNew[reportData._id] = [];
          stepOneGroupsOptionsNew[reportData._id] = [];
          stepTwoUsersOptionsNew[reportData._id] = [];
          stepTwoGroupsOptionsNew[reportData._id] = [];

          let allGroupsUsers = [];
          let allSingleUsers = [];
          // const selectGroups = [];
          let stepOneAllGroupsUsers = [];
          const stepOneAllSingleUsers = [];
          const stepOneAllGroups = [];

          let stepTwoAllGroupsUsers = [];
          const stepTwoAllSingleUsers = [];
          const stepTwoAllGroups = [];

          if (formValueNew) {
            // console.log(formValueNew);
            if (formValueNew.signature_steps === "0") {
              if (formValueNew.users_and_groups) {
                if (formValueNew.users_and_groups[reportData._id]) {
                  formValueNew.users_and_groups[reportData._id].forEach(
                    (aa) => {
                      if (aa.substring(0, 2) === "g_") {
                        if (
                          signersGroupsGetData &&
                          signersGroupsGetData.signers_groups
                        ) {
                          const result =
                            signersGroupsGetData.signers_groups.find(
                              (ab) => ab._id === aa.replace("g_", "")
                            );
                          if (result && result.signers_group_users) {
                            // const userV = [];

                            // result.signers_group_users.forEach(ac => {
                            //   userV.push(ac.toString());

                            //   // allGroupsUsers.push(ac.toString());
                            //   // allSingleUsers.push(ac.toString());
                            // });

                            // if (signersGroupsGetData && signersGroupsGetData.out_of_office_all_assignees) {
                            //   const foundA0 = (_.intersection(signersGroupsGetData.out_of_office_all_assignees, result.signers_group_users));

                            //   if (foundA0.length > 0) {
                            //     // message.error('This group has been assigned as an alternate signer view by out of the office.');
                            //     // const filterVal = formValueNew.users_and_groups[reportData._id].filter(key => key !== aa);
                            //     // this.formFourFormRef.current.setFieldsValue({ users_and_groups: { [reportData._id]: filterVal } });
                            //     return;
                            //   }
                            // }

                            allGroupsUsers = _.concat(
                              allGroupsUsers,
                              result.signers_group_users
                            );
                          }
                        }
                      }
                      if (aa.substring(0, 2) === "u_") {
                        // if (signersGroupsGetData && signersGroupsGetData.out_of_office_all_assignees) {
                        //   if (signersGroupsGetData.out_of_office_all_assignees.includes(aa.replace("u_", ""))) {
                        //     // message.error('This user has been assigned as an alternate signer view by out of the office.');
                        //     // const filterVal = formValueNew.users_and_groups[reportData._id].filter(key => key !== aa);
                        //     // this.formFourFormRef.current.setFieldsValue({ users_and_groups: { [reportData._id]: filterVal } });
                        //     return;
                        //   }

                        // }
                        allSingleUsers.push(aa.replace("u_", ""));
                      }
                    }
                  );

                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === DAILY
                  ) {
                    if (
                      formValueNew.users_and_groups[reportData._id] &&
                      formValueNew.users_and_groups[reportData._id].length > 0
                    ) {
                      validate.users_and_groups.Daily = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === WEEKLY
                  ) {
                    if (
                      formValueNew.users_and_groups[reportData._id] &&
                      formValueNew.users_and_groups[reportData._id].length > 0
                    ) {
                      validate.users_and_groups.Weekly = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === MONTHLY
                  ) {
                    if (
                      formValueNew.users_and_groups[reportData._id] &&
                      formValueNew.users_and_groups[reportData._id].length > 0
                    ) {
                      validate.users_and_groups.Monthly = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === YEARLY
                  ) {
                    if (
                      formValueNew.users_and_groups[reportData._id] &&
                      formValueNew.users_and_groups[reportData._id].length > 0
                    ) {
                      validate.users_and_groups.Yearly = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === QUARTERLY
                  ) {
                    if (
                      formValueNew.users_and_groups[reportData._id] &&
                      formValueNew.users_and_groups[reportData._id].length > 0
                    ) {
                      validate.users_and_groups.Quarterly = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === ASNEEDED
                  ) {
                    if (
                      formValueNew.users_and_groups[reportData._id] &&
                      formValueNew.users_and_groups[reportData._id].length > 0
                    ) {
                      validate.users_and_groups.AsNeeded = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === BIANNUALLY
                  ) {
                    if (
                      formValueNew.users_and_groups[reportData._id] &&
                      formValueNew.users_and_groups[reportData._id].length > 0
                    ) {
                      validate.users_and_groups.BiAnnual = true;
                    }
                  }
                  if (d.report_id && d.report_id.shedule_type) {
                    if (
                      formValueNew.users_and_groups[reportData._id] &&
                      formValueNew.users_and_groups[reportData._id].length > 0
                    ) {
                      validate.users_and_groups_all = true;
                    }
                  }
                }
              }
            }
            if (formValueNew.signature_steps === "1") {
              if (formValueNew.users_and_groups_step_1) {
                if (formValueNew.users_and_groups_step_1[reportData._id]) {
                  formValueNew.users_and_groups_step_1[reportData._id].forEach(
                    (aa) => {
                      if (aa.substring(0, 2) === "g_") {
                        if (
                          signersGroupsGetData &&
                          signersGroupsGetData.signers_groups
                        ) {
                          const result =
                            signersGroupsGetData.signers_groups.find(
                              (ab) => ab._id === aa.replace("g_", "")
                            );
                          if (result && result.signers_group_users) {
                            // result.signers_group_users.forEach(ac => {
                            //   stepOneAllGroupsUsers.push(ac.toString());
                            // });
                            // if (signersGroupsGetData && signersGroupsGetData.out_of_office_all_assignees) {
                            //   const foundA1 = (_.intersection(signersGroupsGetData.out_of_office_all_assignees, result.signers_group_users));
                            //   if (foundA1.length > 0) {
                            //     message.error('This group has been assigned as an alternate signer view by out of the office.');
                            //     const filterVal = formValueNew.users_and_groups_step_1[reportData._id].filter(key => key !== aa);
                            //     this.formFourFormRef.current.setFieldsValue({ users_and_groups_step_1: { [reportData._id]: filterVal } });
                            //     return;
                            //   }
                            // }
                            stepOneAllGroupsUsers = _.concat(
                              stepOneAllGroupsUsers,
                              result.signers_group_users
                            );
                            stepOneAllGroups.push(aa.replace("g_", ""));
                          }
                        }
                      }
                      if (aa.substring(0, 2) === "u_") {
                        // if (signersGroupsGetData.out_of_office_all_assignees.includes(aa.replace("u_", ""))) {
                        //   message.error('This user has been assigned as an alternate signer view by out of the office.');
                        //   const filterVal = formValueNew.users_and_groups_step_1[reportData._id].filter(key => key !== aa);
                        //   this.formFourFormRef.current.setFieldsValue({ users_and_groups_step_1: { [reportData._id]: filterVal } });
                        //   return;
                        // }
                        stepOneAllSingleUsers.push(aa.replace("u_", ""));
                      }
                    }
                  );

                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === DAILY
                  ) {
                    if (
                      formValueNew.users_and_groups_step_1[reportData._id] &&
                      formValueNew.users_and_groups_step_1[reportData._id]
                        .length > 0
                    ) {
                      validate.users_and_groups_step_1.Daily = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === WEEKLY
                  ) {
                    if (
                      formValueNew.users_and_groups_step_1[reportData._id] &&
                      formValueNew.users_and_groups_step_1[reportData._id]
                        .length > 0
                    ) {
                      validate.users_and_groups_step_1.Weekly = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === MONTHLY
                  ) {
                    if (
                      formValueNew.users_and_groups_step_1[reportData._id] &&
                      formValueNew.users_and_groups_step_1[reportData._id]
                        .length > 0
                    ) {
                      validate.users_and_groups_step_1.Monthly = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === YEARLY
                  ) {
                    if (
                      formValueNew.users_and_groups_step_1[reportData._id] &&
                      formValueNew.users_and_groups_step_1[reportData._id]
                        .length > 0
                    ) {
                      validate.users_and_groups_step_1.Yearly = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === QUARTERLY
                  ) {
                    if (
                      formValueNew.users_and_groups_step_1[reportData._id] &&
                      formValueNew.users_and_groups_step_1[reportData._id]
                        .length > 0
                    ) {
                      validate.users_and_groups_step_1.Quarterly = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === ASNEEDED
                  ) {
                    if (
                      formValueNew.users_and_groups_step_1[reportData._id] &&
                      formValueNew.users_and_groups_step_1[reportData._id]
                        .length > 0
                    ) {
                      validate.users_and_groups_step_1.AsNeeded = true;
                    }
                  }
                  if (
                    d.report_id &&
                    d.report_id.shedule_type &&
                    d.report_id.shedule_type === BIANNUALLY
                  ) {
                    if (
                      formValueNew.users_and_groups_step_1[reportData._id] &&
                      formValueNew.users_and_groups_step_1[reportData._id]
                        .length > 0
                    ) {
                      validate.users_and_groups_step_1.BiAnnual = true;
                    }
                  }
                  if (d.report_id && d.report_id.shedule_type) {
                    if (
                      formValueNew.users_and_groups_step_1[reportData._id] &&
                      formValueNew.users_and_groups_step_1[reportData._id]
                        .length > 0
                    ) {
                      validate.users_and_groups_step_1_all = true;
                    }
                  }
                }
              }
              if (formValueNew.users_and_groups_step_2) {
                if (formValueNew.users_and_groups_step_2[reportData._id]) {
                  formValueNew.users_and_groups_step_2[reportData._id].forEach(
                    (ba) => {
                      if (ba.substring(0, 2) === "g_") {
                        if (
                          signersGroupsGetData &&
                          signersGroupsGetData.signers_groups
                        ) {
                          const resultB =
                            signersGroupsGetData.signers_groups.find(
                              (bb) => bb._id === ba.replace("g_", "")
                            );
                          if (resultB && resultB.signers_group_users) {
                            // stepTwoAllGroups.push(ba.replace("g_", ""));
                            // resultB.signers_group_users.forEach(bc => {
                            //   stepTwoAllGroupsUsers.push(bc.toString());
                            // });

                            // if (signersGroupsGetData && signersGroupsGetData.out_of_office_all_assignees) {
                            //   const foundA2 = (_.intersection(signersGroupsGetData.out_of_office_all_assignees, resultB.signers_group_users));
                            //   if (foundA2.length > 0) {
                            //     message.error('This group has been assigned as an alternate signer view by out of the office.');
                            //     const filterVal = formValueNew.users_and_groups_step_2[reportData._id].filter(key => key !== ba);
                            //     this.formFourFormRef.current.setFieldsValue({ users_and_groups_step_2: { [reportData._id]: filterVal } });
                            //     return;
                            //   }
                            // }
                            stepTwoAllGroupsUsers = _.concat(
                              stepTwoAllGroupsUsers,
                              resultB.signers_group_users
                            );
                            stepTwoAllGroups.push(ba.replace("g_", ""));
                          }
                        }
                      }
                      if (ba.substring(0, 2) === "u_") {
                        // if (signersGroupsGetData.out_of_office_all_assignees.includes(ba.replace("u_", ""))) {
                        //   message.error('This user has been assigned as an alternate signer view by out of the office.');
                        //   const filterVal = formValueNew.users_and_groups_step_2[reportData._id].filter(key => key !== ba);
                        //   this.formFourFormRef.current.setFieldsValue({ users_and_groups_step_2: { [reportData._id]: filterVal } });
                        //   return;
                        // }
                        stepTwoAllSingleUsers.push(ba.replace("u_", ""));
                      }
                    }
                  );
                }
              }
            }
          }

          if (signersGroupsGetData.users) {
            signersGroupsGetData.users.forEach((k) => {
              if (allGroupsUsers.includes(k._id.toString())) {
              } else {
                usersOptionsNew[reportData._id].push(k);
              }
              if (
                stepOneAllGroupsUsers.includes(k._id.toString()) ||
                stepTwoAllGroupsUsers.includes(k._id.toString()) ||
                stepTwoAllSingleUsers.includes(k._id.toString())
              ) {
              } else {
                stepOneUsersOptionsNew[reportData._id].push(k);
              }
              if (
                stepTwoAllGroupsUsers.includes(k._id.toString()) ||
                stepOneAllGroupsUsers.includes(k._id.toString()) ||
                stepOneAllSingleUsers.includes(k._id.toString())
              ) {
              } else {
                stepTwoUsersOptionsNew[reportData._id].push(k);
              }
            });
          }

          if (signersGroupsGetData.signers_groups) {
            signersGroupsGetData.signers_groups.forEach((g) => {
              const found = _.intersection(
                allSingleUsers,
                g.signers_group_users
              );
              // if (found.length > 0 && !selectGroups.includes(g._id)) {
              if (found.length > 0) {
              } else {
                groupsOptionsNew[reportData._id].push(g);
              }
              const found2 = _.intersection(
                stepOneAllSingleUsers,
                g.signers_group_users
              );
              const found3 = _.intersection(
                stepTwoAllSingleUsers,
                g.signers_group_users
              );

              if (
                found2.length > 0 ||
                found3.length > 0 ||
                stepTwoAllGroups.includes(g._id.toString())
              ) {
              } else {
                stepOneGroupsOptionsNew[reportData._id].push(g);
              }

              if (
                found3.length > 0 ||
                found2.length > 0 ||
                stepOneAllGroups.includes(g._id.toString())
              ) {
              } else {
                stepTwoGroupsOptionsNew[reportData._id].push(g);
              }
            });
          }
        }
      });
    }

    if (signersGroupsGetData && signersGroupsGetData.signers_groups_option) {
      const optionData = signersGroupsGetData.signers_groups_option;

      if (optionData.signature_steps)
        formFourInitialValues.signature_steps = "1";
      if (optionData.signature_sheet_required_type)
        formFourInitialValues.signature_sheet_required_type =
          optionData.signature_sheet_required_type.toString();
      if (optionData.check_list) formFourInitialValues.check_list = "1";
      if (optionData.check_list_type)
        formFourInitialValues.check_list_type = optionData.check_list_type;
      if (optionData.check_list_position)
        formFourInitialValues.check_list_position =
          optionData.check_list_position;
      if (optionData.select_list_user)
        formFourInitialValues.select_list_user = optionData.select_list_user;
      if (optionData.select_list_group)
        formFourInitialValues.select_list_group = optionData.select_list_group;
    }

    let clearOne = () => {
      const formValue = this.formFourFormRef.current.getFieldValue();

      if (formValue.signature_steps === "0") {
        this.formFourFormRef.current.setFieldsValue(formFourClerValues);
      }
      if (formValue.signature_steps === "1") {
        this.formFourFormRef.current.setFieldsValue(formFourClerValuesStep);
      }
      this.setState({ change: "value" });
    };

    let duplicate = (value) => {
      const formValue = this.formFourFormRef.current.getFieldValue();
      let firstReportId = null;
      let firstFormValue = [];
      let firstFormValueStep1 = [];
      let firstFormValueStep2 = [];
      let duplicateReports = [];
      if (value === "dailyReports") {
        if (dailyReports && dailyReports[0] && dailyReports[0]._id) {
          firstReportId = dailyReports[0]._id;
          duplicateReports = dailyReports;
        }
      }
      if (value === "weeklyReports") {
        if (weeklyReports && weeklyReports[0] && weeklyReports[0]._id) {
          firstReportId = weeklyReports[0]._id;
          duplicateReports = weeklyReports;
        }
      }
      if (value === "monthlyReports") {
        if (monthlyReports && monthlyReports[0] && monthlyReports[0]._id) {
          firstReportId = monthlyReports[0]._id;
          duplicateReports = monthlyReports;
        }
      }
      if (value === "yearlyReports") {
        if (yearlyReports && yearlyReports[0] && yearlyReports[0]._id) {
          firstReportId = yearlyReports[0]._id;
          duplicateReports = yearlyReports;
        }
      }
      if (value === "quarterlyReports") {
        if (
          quarterlyReports &&
          quarterlyReports[0] &&
          quarterlyReports[0]._id
        ) {
          firstReportId = quarterlyReports[0]._id;
          duplicateReports = quarterlyReports;
        }
      }
      if (value === "asNeededReports") {
        if (asNeededReports && asNeededReports[0] && asNeededReports[0]._id) {
          firstReportId = asNeededReports[0]._id;
          duplicateReports = asNeededReports;
        }
      }
      if (value === "biAnnualReports") {
        if (biAnnualReports && biAnnualReports[0] && biAnnualReports[0]._id) {
          firstReportId = biAnnualReports[0]._id;
          duplicateReports = biAnnualReports;
        }
      }

      if (
        formValue &&
        formValue.users_and_groups &&
        formValue.users_and_groups[firstReportId]
      ) {
        firstFormValue = formValue.users_and_groups[firstReportId];
      }
      if (
        formValue &&
        formValue.users_and_groups_step_1 &&
        formValue.users_and_groups_step_1[firstReportId]
      ) {
        firstFormValueStep1 = formValue.users_and_groups_step_1[firstReportId];
      }
      if (
        formValue &&
        formValue.users_and_groups_step_2 &&
        formValue.users_and_groups_step_2[firstReportId]
      ) {
        firstFormValueStep2 = formValue.users_and_groups_step_2[firstReportId];
      }

      const duplicateSetValue = {};
      duplicateSetValue.users_and_groups = {};
      duplicateSetValue.users_and_groups_step_1 = {};
      duplicateSetValue.users_and_groups_step_2 = {};
      duplicateReports.forEach((a) => {
        if (formValue.signature_steps === "0") {
          duplicateSetValue.users_and_groups[a._id] = firstFormValue;
        }
        if (formValue.signature_steps === "1") {
          duplicateSetValue.users_and_groups_step_1[a._id] =
            firstFormValueStep1;
          duplicateSetValue.users_and_groups_step_2[a._id] =
            firstFormValueStep2;
        }
      });

      this.formFourFormRef.current.setFieldsValue(duplicateSetValue);
      this.setState({ change: value });
    };

    const usersOptions = signersGroupsGetData.users.map((d) => (
      <Option key={"u_" + d._id} value={d.email ? "u_" + d._id : "no_email"}>
        {d.name} - {d.user_name} - {d.email}
      </Option>
    ));

    const groupsOptions = signersGroupsGetData.signers_groups.map((d) => (
      <Option key={"g_" + d._id}>{d.signers_group_name}</Option>
    ));

    const groupsOptionsSteps = signersGroupsGetData.signers_groups.map((d) => (
      <Option key={"g_" + d._id} disabled>{d.signers_group_name} - (Step do not support signer groups)</Option>
    ));

    let columns = [
      // {
      //   title: 'Report ID',
      //   dataIndex: '_id',
      //   key: '_id',
      //   width: "200px",
      // },
      {
        title: "Report Name",
        dataIndex: "ReportName",
        key: "ReportName",
        width: "20%",
      },
      {
        title: "Report Category",
        dataIndex: "report_category",
        key: "report_category",
        width: "20%",
        render: (categories) => (
          <span>
            {categories
              ? categories.map((category) => (
                <Tag
                  color="blue"
                  key={category._id}
                  style={{ marginRight: "2px", marginBottom: "2px" }}
                >
                  {category.name}
                </Tag>
              ))
              : null}
          </span>
        ),
      },
    ];

    // console.log(validate, "validate");

    if (this.state.signature_steps === "0") {
      columns.push({
        title: "Users and Groups",
        dataIndex: "users_and_groups",
        key: "users_and_groups",
        width: "60%",
        render: (text, record) => (
          <div>
            {/* {console.log(validate.users_and_groups[record.shedule_type], "aaaaaaaaaaa")}
{console.log(validate.users_and_groups && validate.users_and_groups[record.shedule_type] ? true : false, "bbbbb")} */}
            <Form.Item
              name={["users_and_groups", record._id]}
              // noStyle={true}
              rules={[
                {
                  required:
                    !validate.users_and_groups_all &&
                      ((dailyReports[0] && dailyReports[0]._id === record._id) ||
                        (weeklyReports[0] &&
                          weeklyReports[0]._id === record._id) ||
                        (monthlyReports[0] &&
                          monthlyReports[0]._id === record._id) ||
                        (yearlyReports[0] &&
                          yearlyReports[0]._id === record._id) ||
                        (quarterlyReports[0] &&
                          quarterlyReports[0]._id === record._id) ||
                        (asNeededReports[0] &&
                          asNeededReports[0]._id === record._id) ||
                        (biAnnualReports[0] &&
                          biAnnualReports[0]._id === record._id))
                      ? true
                      : false,
                  message: "At least one report should have signer(s) assigned",
                },
              ]}
              wrapperCol={{ span: 24 }}
              className="is_custom_validation_1"
            >
              <Select
                mode="multiple"
                showSearch
                // onChange={this.usersAndGroupsOnChange}
                onChange={(e) =>
                  this.usersAndGroupsOnChangeNew(
                    e,
                    record._id,
                    "users_and_groups"
                  )
                }
                optionFilterProp="children"
                notFoundContent={null}
              >
                <OptGroup label="Groups">
                  {groupsOptions}
                  {/* {
                    groupsOptionsNew[record._id].map(d => (
                      <Option key={"g_" + d._id}>
                        {d.signers_group_name}
                      </Option>
                    ))
                  } */}
                </OptGroup>
                <OptGroup label="Users">
                  {usersOptions}
                  {/* {
                    usersOptionsNew[record._id].map(d => (
                      <Option key={"u_" + d._id}  value={d.email ? "u_" + d._id : "no_email"}>
                        {d.name} - {d.user_name} - {d.email}
                      </Option>
                    ))
                  } */}
                </OptGroup>
              </Select>
            </Form.Item>
          </div>
        ),
      });
    } else {
      columns.push(
        {
          title: "Users and Groups Step 1",
          dataIndex: "users_and_groups_step_1",
          key: "users_and_groups_step_1",
          width: "30%",
          render: (text, record) => (
            <div>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.users_and_groups_step_2 !==
                  currentValues.users_and_groups_step_2
                }
              >
                {({ getFieldValue }) => (
                  <Form.Item
                    name={["users_and_groups_step_1", record._id]}
                    // noStyle={true}
                    rules={[
                      {
                        required:
                          !validate.users_and_groups_step_1_all &&
                            ((dailyReports[0] &&
                              dailyReports[0]._id === record._id) ||
                              (weeklyReports[0] &&
                                weeklyReports[0]._id === record._id) ||
                              (monthlyReports[0] &&
                                monthlyReports[0]._id === record._id) ||
                              (yearlyReports[0] &&
                                yearlyReports[0]._id === record._id) ||
                              (quarterlyReports[0] &&
                                quarterlyReports[0]._id === record._id) ||
                              (asNeededReports[0] &&
                                asNeededReports[0]._id === record._id) ||
                              (biAnnualReports[0] &&
                                biAnnualReports[0]._id === record._id))
                            ? true
                            : false,
                        message:
                          "At least one report should have signer(s) assigned",
                      },
                      {
                        validator: async (rule, value) => {
                          if (
                            getFieldValue([
                              "users_and_groups_step_2",
                              record._id,
                            ]) &&
                            getFieldValue([
                              "users_and_groups_step_2",
                              record._id,
                            ]).length > 0
                          ) {
                            if (value.length > 0) {
                              return Promise.resolve();
                            }
                            return Promise.reject("Signer(s) required");
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ]}
                    wrapperCol={{ span: 24 }}
                    className="is_custom_validation_1"
                  >
                    <Select
                      mode="multiple"
                      showSearch
                      onChange={(e) =>
                        this.usersAndGroupsOnChangeNew(
                          e,
                          record._id,
                          "users_and_groups_step_1"
                        )
                      }
                      optionFilterProp="children"
                      notFoundContent={null}
                    >
                      <OptGroup label="Groups">
                        {groupsOptions}
                        {/* {
                    stepOneGroupsOptionsNew[record._id].map(d => (
                      <Option key={"g_" + d._id}>
                        {d.signers_group_name}
                      </Option>
                    ))
                  } */}
                      </OptGroup>
                      <OptGroup label="Users">
                        {usersOptions}
                        {/* {
                    stepOneUsersOptionsNew[record._id].map(d => (
                      <Option key={"u_" + d._id} value={d.email ? "u_" + d._id : "no_email"}>
                        {d.name} - {d.user_name} - {d.email}
                      </Option>
                    ))
                  } */}
                      </OptGroup>
                    </Select>
                  </Form.Item>
                )}
              </Form.Item>
            </div>
          ),
        },
        {
          title: "Users and Groups Step 2",
          dataIndex: "users_and_groups_step_2",
          key: "users_and_groups_step_2",
          width: "30%",
          render: (text, record) => (
            <div>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.users_and_groups_step_2 !==
                  currentValues.users_and_groups_step_2
                }
              >
                {({ getFieldValue }) => (
                  <Form.Item
                    name={["users_and_groups_step_2", record._id]}
                    // noStyle={true}
                    rules={[
                      {
                        required:
                          getFieldValue([
                            "users_and_groups_step_1",
                            record._id,
                          ]) &&
                            getFieldValue(["users_and_groups_step_1", record._id])
                              .length > 0
                            ? true
                            : false,
                        message: " ",
                      },
                      {
                        validator: async (rule, value) => {
                          if (
                            !validate.users_and_groups_step_1_all &&
                            ((dailyReports[0] &&
                              dailyReports[0]._id === record._id) ||
                              (weeklyReports[0] &&
                                weeklyReports[0]._id === record._id) ||
                              (monthlyReports[0] &&
                                monthlyReports[0]._id === record._id) ||
                              (yearlyReports[0] &&
                                yearlyReports[0]._id === record._id) ||
                              (quarterlyReports[0] &&
                                quarterlyReports[0]._id === record._id) ||
                              (asNeededReports[0] &&
                                asNeededReports[0]._id === record._id) ||
                              (biAnnualReports[0] &&
                                biAnnualReports[0]._id === record._id))
                          ) {

                            return Promise.reject(" ");
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ]}
                    wrapperCol={{ span: 24 }}
                    className="is_custom_validation_1"
                  >
                    <Select
                      mode="multiple"
                      showSearch
                      onChange={(e) =>
                        this.usersAndGroupsOnChangeNew(
                          e,
                          record._id,
                          "users_and_groups_step_2"
                        )
                      }
                      optionFilterProp="children"
                      notFoundContent={null}
                    >
                      <OptGroup label="Groups">
                        {groupsOptionsSteps}
                        {/* {
                    stepTwoGroupsOptionsNew[record._id].map(d => (
                      <Option key={"g_" + d._id}>
                        {d.signers_group_name}
                      </Option>
                    ))
                  } */}
                      </OptGroup>
                      <OptGroup label="Users">
                        {usersOptions}
                        {/* {
                    stepTwoUsersOptionsNew[record._id].map(d => (
                      <Option key={"u_" + d._id} disabled={d.email? false : true }>
                        {d.name} - {d.user_name} - {d.email}
                      </Option>
                    ))
                  } */}
                      </OptGroup>
                    </Select>
                  </Form.Item>
                )}
              </Form.Item>
            </div>
          ),
        }
      );
    }

    let test = async (value) => {
      console.log(value);
      this.formFourFormRef.current.validateFields();
    };

    return (
      <Form
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 6 }}
        ref={this.formFourFormRef}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={formFourInitialValues}
        scrollToFirstError={true}
      >
        <Form.Item
          name="signature_steps"
          label="Do you like to define Signature Steps ?"
          // onChange={this.signatureStepsOnChange}
          // onClick={this.signatureStepsOnChange}
          className="is_white_space_normal"
        >
          <Radio.Group onChange={this.signatureStepsOnChange}>
            <Radio value="1">Yes</Radio>
            <Radio value="0">No</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="signature_sheet_required_type"
          //  initialValue="1"
          label="Do you need Signature Sheet ?"
          className="is_white_space_normal"
          style={{ display: "none" }}
        >
          <Radio.Group onChange={test}>
            <Radio value="1">After each report</Radio>
            <Radio value="2">At the end</Radio>
            <Radio value="3">None</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="check_list"
          label="Check List"
          style={{ display: "none" }}
        >
          <Radio.Group>
            <Radio value="1">Yes</Radio>
            <Radio value="0">No</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.check_list !== currentValues.check_list
          }
        >
          {({ getFieldValue }) =>
            getFieldValue("check_list") === "1" ? (
              <div>
                <Form.Item
                  name="check_list_position"
                  label="Check List Position"
                >
                  <Radio.Group>
                    <Radio value="Top">Top</Radio>
                    <Radio value="Bottom">Bottom</Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item name="check_list_type" label="Check List User">
                  <Radio.Group>
                    <Radio value="Group">Group</Radio>
                    <Radio value="Individual">Individual</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.check_list_type !==
                    currentValues.check_list_type ||
                    prevValues.users_and_groups !==
                    currentValues.users_and_groups ||
                    prevValues.users_and_groups_step_1 !==
                    currentValues.users_and_groups_step_1 ||
                    prevValues.users_and_groups_step_2 !==
                    currentValues.users_and_groups_step_2
                  }
                >
                  {({ getFieldValue, setFieldsValue }) => {
                    const selectedUsersAndGroups = [];
                    const signatureStepsValue =
                      getFieldValue("signature_steps");
                    const selectListUserValue =
                      getFieldValue("select_list_user");
                    let clearSelect = true;
                    if (signatureStepsValue === "0") {
                      const usersAndGroupsOne =
                        getFieldValue("users_and_groups");
                      if (usersAndGroupsOne) {
                        Object.keys(usersAndGroupsOne).forEach(function (key) {
                          if (usersAndGroupsOne[key]) {
                            usersAndGroupsOne[key].forEach((a) => {
                              selectedUsersAndGroups.push(a);
                            });
                          }
                        });
                      }
                    }
                    if (signatureStepsValue === "1") {
                      const usersAndGroupsStep1 = getFieldValue(
                        "users_and_groups_step_1"
                      );
                      const usersAndGroupsStep2 = getFieldValue(
                        "users_and_groups_step_2"
                      );
                      if (usersAndGroupsStep1) {
                        Object.keys(usersAndGroupsStep1).forEach(function (
                          key
                        ) {
                          if (usersAndGroupsStep1[key]) {
                            usersAndGroupsStep1[key].forEach((a) => {
                              selectedUsersAndGroups.push(a);
                            });
                          }
                        });
                      }
                      if (usersAndGroupsStep2) {
                        Object.keys(usersAndGroupsStep2).forEach(function (
                          key
                        ) {
                          if (usersAndGroupsStep2[key]) {
                            usersAndGroupsStep2[key].forEach((a) => {
                              selectedUsersAndGroups.push(a);
                            });
                          }
                        });
                      }
                    }

                    selectListUsers = [];
                    signersGroupsGetData.users.forEach((d) => {
                      if (selectedUsersAndGroups.includes("u_" + d._id)) {
                        if (selectListUserValue === d._id) clearSelect = false;

                        selectListUsers.push(
                          <Option key={d._id} value={d._id}>
                            {d.name} - {d.user_name} - {d.email}
                          </Option>
                        );
                      }
                    });

                    if (clearSelect) {
                      setFieldsValue({ select_list_user: null });
                    }

                    if (getFieldValue("check_list_type") === "Individual") {
                      return (
                        <Form.Item
                          name="select_list_user"
                          label="Select User"
                          rules={[
                            {
                              required: getFieldValue("check_list"),
                              message: "Please input user!",
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            allowClear={true}
                            optionFilterProp="children"
                            notFoundContent={null}
                          >
                            {selectListUsers}
                          </Select>
                        </Form.Item>
                      );
                    }
                  }}
                </Form.Item>

                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.check_list_type !==
                    currentValues.check_list_type ||
                    prevValues.users_and_groups !==
                    currentValues.users_and_groups ||
                    prevValues.users_and_groups_step_1 !==
                    currentValues.users_and_groups_step_1 ||
                    prevValues.users_and_groups_step_2 !==
                    currentValues.users_and_groups_step_2
                  }
                >
                  {({ getFieldValue, setFieldsValue }) => {
                    const selectedUsersAndGroups = [];
                    const signatureStepsValue =
                      getFieldValue("signature_steps");
                    const selectListGroupValue =
                      getFieldValue("select_list_group");
                    let clearSelect = true;
                    if (signatureStepsValue === "0") {
                      const usersAndGroupsOne =
                        getFieldValue("users_and_groups");
                      if (usersAndGroupsOne) {
                        Object.keys(usersAndGroupsOne).forEach(function (key) {
                          if (usersAndGroupsOne[key]) {
                            usersAndGroupsOne[key].forEach((a) => {
                              selectedUsersAndGroups.push(a);
                            });
                          }
                        });
                      }
                    }
                    if (signatureStepsValue === "1") {
                      const usersAndGroupsStep1 = getFieldValue(
                        "users_and_groups_step_1"
                      );
                      const usersAndGroupsStep2 = getFieldValue(
                        "users_and_groups_step_2"
                      );
                      if (usersAndGroupsStep1) {
                        Object.keys(usersAndGroupsStep1).forEach(function (
                          key
                        ) {
                          if (usersAndGroupsStep1[key]) {
                            usersAndGroupsStep1[key].forEach((a) => {
                              selectedUsersAndGroups.push(a);
                            });
                          }
                        });
                      }
                      if (usersAndGroupsStep2) {
                        Object.keys(usersAndGroupsStep2).forEach(function (
                          key
                        ) {
                          if (usersAndGroupsStep2[key]) {
                            usersAndGroupsStep2[key].forEach((a) => {
                              selectedUsersAndGroups.push(a);
                            });
                          }
                        });
                      }
                    }

                    selectListGroups = [];
                    signersGroupsGetData.signers_groups.forEach((d) => {
                      if (selectedUsersAndGroups.includes("g_" + d._id)) {
                        if (selectListGroupValue === d._id) clearSelect = false;
                        selectListGroups.push(
                          <Option key={d._id} value={d._id}>
                            {d.signers_group_name}
                          </Option>
                        );
                      }
                    });

                    if (clearSelect) {
                      setFieldsValue({ select_list_group: null });
                    }

                    if (getFieldValue("check_list_type") === "Group") {
                      return (
                        <Form.Item
                          name="select_list_group"
                          label="Select Group"
                          rules={[
                            {
                              required: getFieldValue("check_list"),
                              message: "Please input group!",
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            optionLabelProp="children"
                            allowClear={true}
                            notFoundContent={null}
                          >
                            {selectListGroups}
                          </Select>
                        </Form.Item>
                      );
                    }
                  }}

                  {/* {({ getFieldValue }) =>
                    getFieldValue('check_list_type') === 'Group' ? (
                      <div>
                        <Form.Item
                          name="select_list_group"
                          label="Select Group">
                          <Select
                            showSearch
                            allowClear={true}
                            optionFilterProp="children"
                            notFoundContent={null}
                          >
                            {selectListGroups}
                          </Select>
                        </Form.Item>
                      </div>
                    ) : null
                  } */}
                </Form.Item>
              </div>
            ) : null
          }
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.signature_steps !== currentValues.signature_steps
          }
        >
          <div>
            {dailyReports.length > 0 ? (
              <div style={{ marginBottom: 30 }}>
                <Row>
                  <Col span={12}>
                    <h3>Daily Reports</h3>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "right", marginBottom: "10px" }}>
                      <Button
                        size="small"
                        onClick={() => duplicate("dailyReports")}
                      >
                        Duplicate First Row
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Table
                  dataSource={dailyReports}
                  columns={columns}
                  size="small"
                  rowKey="_id"
                  pagination={false}
                  scroll={{ x: 1100 }}
                />
              </div>
            ) : null}

            {weeklyReports.length > 0 ? (
              <div style={{ marginBottom: 30 }}>
                <Row>
                  <Col span={12}>
                    <h3>Weekly Reports</h3>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "right", marginBottom: "10px" }}>
                      <Button
                        size="small"
                        onClick={() => duplicate("weeklyReports")}
                      >
                        Duplicate First Row
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Table
                  dataSource={weeklyReports}
                  columns={columns}
                  size="small"
                  rowKey="_id"
                  pagination={false}
                  scroll={{ x: 1100 }}
                />
              </div>
            ) : null}

            {monthlyReports.length > 0 ? (
              <div style={{ marginBottom: 30 }}>
                <Row>
                  <Col span={12}>
                    <h3>Monthly Reports</h3>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "right", marginBottom: "10px" }}>
                      <Button
                        size="small"
                        onClick={() => duplicate("monthlyReports")}
                      >
                        Duplicate First Row
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Table
                  dataSource={monthlyReports}
                  columns={columns}
                  size="small"
                  rowKey="_id"
                  pagination={false}
                  scroll={{ x: 1100 }}
                />
              </div>
            ) : null}

            {quarterlyReports.length > 0 ? (
              <div style={{ marginBottom: 30 }}>
                <Row>
                  <Col span={12}>
                    <h3>Quarterly Reports</h3>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "right", marginBottom: "10px" }}>
                      <Button
                        size="small"
                        onClick={() => duplicate("quarterlyReports")}
                      >
                        Duplicate First Row
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Table
                  dataSource={quarterlyReports}
                  columns={columns}
                  size="small"
                  rowKey="_id"
                  pagination={false}
                  scroll={{ x: 1100 }}
                />
              </div>
            ) : null}

            {biAnnualReports.length > 0 ? (
              <div style={{ marginBottom: 30 }}>
                <Row>
                  <Col span={12}>
                    <h3>Bi Annually Reports</h3>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "right", marginBottom: "10px" }}>
                      <Button
                        size="small"
                        onClick={() => duplicate("biAnnualReports")}
                      >
                        Duplicate First Row
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Table
                  dataSource={biAnnualReports}
                  columns={columns}
                  size="small"
                  rowKey="_id"
                  pagination={false}
                  scroll={{ x: 1100 }}
                />
              </div>
            ) : null}

            {yearlyReports.length > 0 ? (
              <div style={{ marginBottom: 30 }}>
                <Row>
                  <Col span={12}>
                    <h3>Yearly Reports</h3>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "right", marginBottom: "10px" }}>
                      <Button
                        size="small"
                        onClick={() => duplicate("yearlyReports")}
                      >
                        Duplicate First Row
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Table
                  dataSource={yearlyReports}
                  columns={columns}
                  size="small"
                  rowKey="_id"
                  pagination={false}
                  scroll={{ x: 1100 }}
                />
              </div>
            ) : null}



            {asNeededReports.length > 0 ? (
              <div style={{ marginBottom: 30 }}>
                <Row>
                  <Col span={12}>
                    <h3>As Needed Reports</h3>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "right", marginBottom: "10px" }}>
                      <Button
                        size="small"
                        onClick={() => duplicate("asNeededReports")}
                      >
                        Duplicate First Row
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Table
                  dataSource={asNeededReports}
                  columns={columns}
                  size="small"
                  rowKey="_id"
                  pagination={false}
                  scroll={{ x: 1100 }}
                />
              </div>
            ) : null}



          </div>
        </Form.Item>

        <div style={{ textAlign: "center" }}>
          <Button type="primary" htmlType="submit">
            Update
          </Button>

          <Button onClick={clearOne} style={{ marginLeft: "10px" }}>
            Clear
          </Button>
        </div>
      </Form>
    );
  }
}

// const WrappedApp = Form.create({ name: "form_three" })(FormFour);

// export default WrappedApp;
export default FormFour;
